module.exports = __webpack_public_path__ + "static/media/DBHeaventNow-BoldIt.57a09c07.ttf";